var redireccion = false
export function redireccionar (){
  redireccion = true;
}
export function estadoRedireccion (){
  return redireccion;
}
export function reinicio (){
  redireccion = false;
}